import React, { useState } from 'react';
import { Search } from 'lucide-react';
import { ICON_OPTIONS, resolveIcon } from '../lib/icons';

export default function IconPicker({ value, onChange }) {
  const [search, setSearch] = useState('');
  const filtered = ICON_OPTIONS.filter((n) => n.toLowerCase().includes(search.toLowerCase()));
  return (
    <div>
      <div className="relative mb-2">
        <Search className="absolute left-2 top-2.5 w-4 h-4 text-slate-400" />
        <input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Buscar ícone..."
          className="w-full pl-8 pr-3 py-2 border border-slate-200 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-100 rounded-lg text-sm"
        />
      </div>
      <div className="grid grid-cols-8 gap-1 max-h-48 overflow-y-auto p-1 border border-slate-200 dark:border-slate-700 rounded-lg">
        {filtered.map((name) => {
          const Icon = resolveIcon(name);
          if (!Icon) return null;
          const active = value === name;
          return (
            <button
              key={name}
              type="button"
              onClick={() => onChange(name)}
              title={name}
              className={`p-2 rounded-md flex items-center justify-center ${active ? 'bg-indigo-600 text-white' : 'hover:bg-slate-100 dark:hover:bg-slate-700 text-slate-600 dark:text-slate-300'}`}
            >
              <Icon className="w-4 h-4" />
            </button>
          );
        })}
      </div>
    </div>
  );
}
